import CustomSelection from './custom-selection';

export default class Bet extends CustomSelection {
}
